import { Navigate } from "react-router-dom";
import useUserStore from "../stores/user";
import { useUrl } from "../composables/useUrl";

interface AdminRouteProps {
  children: React.ReactNode;
  requiredRole?: "super_admin";
}

export default function AdminRoute({ children, requiredRole }: AdminRouteProps) {
  const user = useUserStore((state) => state.user);
  const profile = useUserStore((state) => state.profile);
  const authResolved = useUserStore((state) => state.authResolved);
  const { getDashboardUrl } = useUrl();

  // Auth still resolving on cold load — hold, don't bounce to /login-portal
  if (!authResolved) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login-portal" replace />;
  }

  // Profile still loading — hold, don't flash-redirect
  if (!profile) {
    return null;
  }

  const ADMIN_ROLES = ["admin", "district_admin", "super_admin"];
  if (!ADMIN_ROLES.includes(profile.role)) {
    return <Navigate to={getDashboardUrl()} replace />;
  }

  if (requiredRole === "super_admin" && profile.role !== "super_admin") {
    return <Navigate to={getDashboardUrl()} replace />;
  }

  return <>{children}</>;
}
